import React, { useState } from "react";
import { BedData } from "./Service";


export default function Gallery(props:{images:BedData["images"]|null})
{
    const [currentImage,setCurrentImage]=useState<number>(0)

    if(props.images?.length==0)
    {
        return(
            <p>No pictures to display</p>
        )
    }

    function GoNext()
    {
        if(props.images!=null)
        if(props.images?.length-1==currentImage)
        {
            setCurrentImage(0)
        }
        else
        {
            setCurrentImage(currentImage+1)
        }
    }

    function GoPrevious()
    {
        if(props.images!=null)
        if(currentImage==0)
        {
            setCurrentImage(props.images?.length-1)
        }
        else
        {
            setCurrentImage(currentImage-1)
        }
    }

   


    return(
        <>
    <img className="responsiveImg" src={ process.env.REACT_APP_BASE+""+props.images[currentImage]} />
    <div>
    <a 

    onClick={(e)=>{
        e.preventDefault()
        GoPrevious()
    }}
    href=""><svg width="44px" height="44px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M8.16485 11.6296L14.7953 5.1999C15.2091 4.79869 16 5.04189 16 5.5703L16 18.4297C16 18.9581 15.2091 19.2013 14.7953 18.8001L8.16485 12.3704C7.94505 12.1573 7.94505 11.8427 8.16485 11.6296Z" fill="#1C274C"></path> </g></svg></a>
    <a 
    onClick={(e)=>{
        e.preventDefault()
        GoNext()
    }}
    
    href="" style={{marginRight:"10px"}}><svg width="44px" height="44px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M15.8351 11.6296L9.20467 5.1999C8.79094 4.79869 8 5.04189 8 5.5703L8 18.4297C8 18.9581 8.79094 19.2013 9.20467 18.8001L15.8351 12.3704C16.055 12.1573 16.0549 11.8427 15.8351 11.6296Z" fill="#1C274C"></path> </g></svg></a>
    
    </div>
</>
    )
}